import React, { useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './App.css';

function App() {
 useEffect(() => {
  // Add scroll-triggered animations
  const observerOptions = {
   threshold: 0.1,
   rootMargin: '0px 0px -50px 0px',
  };

  const observer = new IntersectionObserver((entries) => {
   entries.forEach((entry) => {
    if (entry.isIntersecting) {
     entry.target.classList.add('animate-fade-in-up');
    }
   });
  }, observerOptions);

  // Observe all sections
  const sections = document.querySelectorAll('.section');
  sections.forEach((section) => {
   observer.observe(section);
  });

  return () => observer.disconnect();
 }, []);

 return (
  <div className='App'>
   <Header />
   <Hero />
   <Services />
   <About />
   <Contact />
   <Footer />
  </div>
 );
}

export default App;
